import React, { useState } from "react";
import "../../../assets/css/templateBuilder.css";
import "../../../assets/css/addunit.css";
import "../../../assets/css/mainMenu.css";
import ArrowLineRight from "../../../assets/icons/ArrowLineRight.svg";

const Sidebar = ({ master, usedTemplateTypeIds, searchQuery }) => {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const onDragStart = (event, masterId) => {
    event.dataTransfer.setData("application/reactflow", masterId);
    event.dataTransfer.effectAllowed = "move";
  };

  const getGroupedItems = (items) => {
    const groupedItems = [];
    for (let i = 0; i < items.length; i += 2) {
      groupedItems.push(items.slice(i, i + 2));
    }
    return groupedItems;
  };

  const handleAccordionClick = (index, isDisabled) => {
    if (isDisabled) {
      setOpenAccordionIndex(null);
    } else {
      setOpenAccordionIndex(openAccordionIndex === index ? null : index);
    }
  };
  const filterAndSortMasters = (templates) => {
    const filteredTemplates = templates.filter((template) =>
      template.template_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Sort the filtered templates such that the items matching the search query are at the top
    filteredTemplates.sort((a, b) => {
      const aMatches = a.template_name.toLowerCase().startsWith(searchQuery.toLowerCase());
      const bMatches = b.template_name.toLowerCase().startsWith(searchQuery.toLowerCase());
      return bMatches - aMatches;
    });

    return filteredTemplates;
  };

  return (
    <div className="row" style={{ marginRight: 0, marginLeft: 0 }}>
      <div className="col-md-3 p-0 left" style={{ width: "300px" }}>
        <div>
          {master && master.length > 0 ? (
            master.map((item, index) => {
              const isDisabled = usedTemplateTypeIds.includes(
                item.templateType._id
              );
              const isOpen = openAccordionIndex === index;

              return (
                <div key={index} className="accordion-item tb-accordion-item">
                  <h2 className="accordion-header" id={`heading${index}`}>
                    <button
                      className="accordion-button d-flex align-content-center justify-content-between"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded={isOpen}
                      aria-controls={`collapse${index}`}
                      disabled={isDisabled}
                      onClick={() => handleAccordionClick(index, isDisabled)}
                    >
                      <div className="d-flex gap-3">
                        <p className="m-0 medium-body">
                          {item.templateType.template_type_name}
                        </p>
                      </div>
                      <img className="icon-rotate" src={ArrowLineRight} alt="" />
                    </button>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                    aria-labelledby={`heading${index}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body tb-accordion-body">
                      {getGroupedItems(filterAndSortMasters(item.templates)).map(
                        (group, groupIndex) => (
                          <div
                            key={groupIndex}
                            className="d-flex justify-content-between gap-2 tb-accordion-body align-content-center mb-2"
                          >
                            {group.map((template) => (
                              <span
                                key={template._id}
                                className={`align-content-center text-truncate text-center dndnode ${isDisabled ? "disabled" : ""
                                  }`}
                                onDragStart={(event) =>
                                  !isDisabled &&
                                  onDragStart(event, template._id)
                                }
                                draggable={!isDisabled}
                              >
                                {template.template_name}
                              </span>
                            ))}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
